module.exports = __webpack_public_path__ + "img/20200512_162213.9c30e311.jpg";